module.exports = __webpack_public_path__ + "media/feature-icons/submission_editing-f5e47178.png";